import { current } from "@reduxjs/toolkit";
import React, { useEffect, useState } from "react";
import { primaryColor } from "../../../../../utility/constants/colorManager";
import { RUPEES_SYMBOL } from "../../../../../utility/constants/valueConstants";
import ResizeListner from "../../../../../utility/ResizeListner";
import "./preview.css";

const PreviewTable = ({ styles, bodyStyle, tableDetails1, currentTab }) => {
  const { height, width } = ResizeListner();
  const [totalAmount, setTotalAmount] = useState("");

  const thStyle = {
    fontWeight: "500",
    fontSize: 14,
  };

  const tdStyle = {
    color: "#242734",
    fontWeight: "normal",
    fontSize: 14,
    maxWidth: 120,
    minWidth: 80,
    wordBreak: "break-all",
    backgroundColor: "rgba(187, 185, 255, 0.01)",
  };

  useEffect(() => {
    let amount = 0;
    tableDetails1 &&
      tableDetails1.map((tab, i) => {
        amount = amount + parseFloat(tab?.amount);
      });
    setTotalAmount(amount);
  }, [tableDetails1]);

  return (
    <div
      style={{
        boxSizing: "border-box",
        overflow: "hidden",
      }}
    >
      <div
        style={{
          overflow: "auto",
          borderBottomRightRadius: 0,
          borderBottomLeftRadius: 0,
          borderRadius: "20px",
          overflow: "auto",
          maxHeight: "400px",
          position: "relative",
          minHeight: "400px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        <table
          style={{
            overflow: "auto",
            minWidth: 300,
            paddingBottom: 20,
            width: "100%",
            ...styles,
          }}
          id="header-fixed"
          className="preview-table"
        >
          <thead
            style={{
              width: "100%",
              position: "sticky",
              top: 0,
            }}
          >
            <tr
              style={{
                borderRadius: 7,
                alignItems: "center",
                opacity: 1,
                width: "100%",
                background: "white",
              }}
              className="preview-tr"
            >
              <th style={thStyle} className="preview-th">
                Name
              </th>
              <th style={thStyle} className="preview-th">
                Bank Name
              </th>

              <th style={thStyle} className="preview-th">
                Bank Account
              </th>

              <th style={thStyle} className="preview-th">
                Bank IFSC
              </th>

              <th style={thStyle} className="preview-th">
                Bene Note
              </th>

              <th style={thStyle} className="preview-th">
                Email
              </th>
              <th style={thStyle} className="preview-th">
                Phone
              </th>

              <th style={thStyle} className="preview-th">
                Remarks
              </th>
              <th style={thStyle} className="preview-th">
                Transfer Mode
              </th>

              <th style={thStyle} className="preview-th">
                Reference Id
              </th>

              <th style={thStyle} className="preview-th">
                Bene Note
              </th>

              <th style={thStyle} className="preview-th">
                Amount
              </th>
            </tr>
          </thead>
          <>
            <tbody
              style={{
                width: "100%",
                ...bodyStyle,
              }}
            >
              {tableDetails1 &&
                tableDetails1
                  ?.map((tab, index) => (
                    <tr style={{}} key={index}>
                      <td style={tdStyle} className="preview-td">
                        {tab?.name ?? "N/A"}
                      </td>

                      <td style={tdStyle} className="preview-td">
                        {" "}
                        {tab?.bankName ?? "N/A"}
                      </td>

                      <td style={tdStyle} className="preview-td">
                        {" "}
                        {tab?.bankAccount ?? "N/A"}
                      </td>
                      <td style={tdStyle} className="preview-td">
                        {" "}
                        {tab?.ifsc ?? "N/A"}
                      </td>
                      <td style={tdStyle} className="preview-td">
                        {" "}
                        {tab?.beneNote ?? "N/A"}
                      </td>

                      <td style={tdStyle} className="preview-td">
                        {" "}
                        {tab?.email ?? "N/A"}
                      </td>


                      <td style={tdStyle} className="preview-td">
                        {" "}
                        {tab?.phone ?? "N/A"}
                      </td>


                      <td style={tdStyle} className="preview-td">
                        {" "}
                        {tab?.remarks ?? "N/A"}
                      </td>


                      <td style={tdStyle} className="preview-td">
                        {" "}
                        {tab?.transferMode ?? "N/A"}
                      </td>

                      <td style={tdStyle} className="preview-td">
                        {" "}
                        {tab?.referenceId ?? "N/A"}
                      </td>

                      <td style={tdStyle} className="preview-td">
                        {" "}
                        {tab?.beneNote ?? "N/A"}
                      </td>


                      <td style={tdStyle} className="preview-td">
                        {" "}
                        {tab?.amount ?? "N/A"}
                      </td>
                    </tr>
                  ))
                  .reverse()}
            </tbody>
          </>
        </table>

        <div
          style={{
            width: "100%",
            backgroundColor: "white",

            position: "sticky",
            bottom: 0,
          }}
        >
          <div
            style={{
              width: "100%",
              backgroundColor: "rgba(187, 185, 255, 0.1)",
              position: "sticky",
              display: "flex",
              justifyContent: "flex-end",
              padding: "10px",
            }}
          >
            <p style={{ ...thStyle, color: "#0C1C61" }}>
              Total Amount : {RUPEES_SYMBOL + " " + totalAmount}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PreviewTable;
